import { trpc } from '@/lib/trpc';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';

const useEditList = () => {
	const utils = trpc.useUtils();
	const { t } = useTranslation();
	const { mutate } = trpc.list.edit.useMutation({
		onMutate: async (list) => {
			await utils.user.get.cancel();

			const listResponse = utils.list.get.getData();

			if (!listResponse) return;

			const updatingList = listResponse.lists.find(
				(l) => l.id === list.id
			);

			if (!updatingList) return;

			const optimisticList = {
				...updatingList,
				name: list.name,
				updated_at: new Date().toISOString(),
			};

			const optimisticLists = listResponse.lists.map((l) =>
				l.id === list.id ? optimisticList : l
			);

			utils.list.get.setData(undefined, () => {
				return { status: 200, lists: optimisticLists };
			});

			return { listResponse };
		},
		onError(_, __, context) {
			if (!context?.listResponse) return;
			utils.list.get.setData(undefined, () => {
				return { status: 200, lists: context?.listResponse.lists };
			});
			toast.error(t('error.generic'));
		},
	});

	return {
		editList: mutate,
	};
};

export default useEditList;
